import React from 'react';
import { motion } from 'framer-motion';
import { CpuIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function TitleSlide() {
  return <SlideLayout className="text-center relative" hideLogo data-id="element-454" data-mp="gc3ym9k1mnxk">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-teal/10 blur-[120px] rounded-full pointer-events-none" data-id="element-455" data-mp="caqqttxe4ao0" />

      <motion.div variants={itemVariants} className="flex flex-col items-center justify-center mb-8" data-id="element-456" data-mp="7cz37c3s3apm">
        <div className="relative" data-id="element-457" data-mp="3tivy5vqqzblk">
          <div className="absolute inset-0 bg-brand-teal/20 blur-xl rounded-full" data-id="element-458" data-mp="3ti44wrkmhpyg" />
          <CpuIcon className="w-24 h-24 text-brand-teal relative z-10 mb-6" strokeWidth={1.5} data-id="element-459" data-mp="3phsipacm3hkv" />
        </div>
        <h1 className="text-6xl md:text-8xl font-bold text-brand-text tracking-tight mb-4" data-id="element-460" data-mp="1rqze1xqiktf6">
          Isochron
        </h1>
        <h2 className="text-2xl md:text-3xl text-brand-teal font-medium tracking-wide" data-id="element-461" data-mp="1no31annnnrj5">
          Give your llama wings.
        </h2>
      </motion.div>

      <motion.div variants={itemVariants} className="max-w-3xl mx-auto mb-12" data-id="element-462" data-mp="10rd8i6lu09kj">
        <p className="text-xl md:text-2xl text-brand-text-dim leading-relaxed" data-id="element-463" data-mp="mr2gv1cp6qyb">
          Better latency, flexible pricing, no vendor lock-in. Access the
          world's most powerful programmable hardware through a single API.
        </p>
      </motion.div>

      <motion.div variants={itemVariants} className="flex items-center justify-center gap-8 text-brand-text-muted font-mono text-sm" data-id="element-464" data-mp="1ejtftjlrmtr9">
        <a href="https://isochron.cloud" className="hover:text-brand-teal transition-colors" data-id="element-465" data-mp="15ode6gerrab4">
          isochron.cloud
        </a>
        <span className="w-1 h-1 rounded-full bg-brand-border" data-id="element-466" data-mp="1xgm93fuxnull" />
        <a href="mailto:founders@isochron.cloud" className="hover:text-brand-teal transition-colors" data-id="element-467" data-mp="1xfb9ls8it90a">
          founders@isochron.cloud
        </a>
      </motion.div>
    </SlideLayout>;
}